<template>
  <router-link :to="{path: navItem.route}" v-if="!(navItem.children&&navItem.children.length)">
    <el-menu-item :class="{sideBarclose: !sideBarOpened}" :index="navItem.route">
      <i v-if="navItem.icon" class="icon iconfont" :class="[navItem.icon]"></i>
      <span slot="title">{{navItem.name}}</span>
    </el-menu-item>
  </router-link>
  <el-submenu v-else :index="navItem.route" popper-class="layout-menu-popper">
    <template slot="title">
      <i v-if="navItem.icon" class="icon iconfont" :class="[navItem.icon]"></i>
      <span slot="title">{{navItem.name}}</span>
    </template>
    <template v-for="(child,index) in navItem.children">
      <side-bar-item
              :navItem="child"
              :key="index"
              class="nest-menu"/>
    </template>
  </el-submenu>
</template>
<script>
	import {mapState} from 'vuex'

	export default {
		name: "side-bar-item",
		props: {
			navItem: {
				type: Object,
				required: true
			},
			basePath: {
				type: String,
				default: ''
			}
		},
		data() {
			return {}
		},
		computed: {
			...mapState({
				sideBarOpened: state => state.sideBarOpened
			})
		},
		methods: {
			// 检测是否有要显示的导航
			hasOneShowingChild(children, parent) {
				const showingChildren = children.filter(item => {
					if (item.hidden) {
						return false
					} else {
						// Temp set(will be used if only has one showing child)
						this.onlyOneChild = item
						return true
					}
				})
				// When there is only one child router, the child router is displayed by default
				if (showingChildren.length === 1) {
					return true
				}
				// Show parent if there are no child router to display
				if (showingChildren.length === 0) {
					this.onlyOneChild = {...parent, path: '', noShowingChildren: true}
					return true
				}

				return false
			},
		}
	}
</script>

<style lang="scss" scoped>
  .side-link {
    display: block;
    height: 100%;
  }

  .icon {
    margin-right: 6px;
  }

  .sideBarclose {
    .icon {
      margin-right: 0;
    }
  }
</style>
